import { Suspense, type ReactNode } from "react";
import { Canvas } from "@react-three/fiber";
import { ACESFilmicToneMapping, PCFSoftShadowMap } from "three";
import { useJourneyStore } from "../state/journeyMachine";
import { QualityManager } from "./QualityManager";

function CanvasFallback() {
  return (
    <div role="status" className="flex h-full items-center justify-center text-sm text-[var(--cale-ink-muted)]">
      Preparando escena 3D…
    </div>
  );
}

export function StageRenderer({ children }: { children: ReactNode }) {
  const quality = useJourneyStore((s) => s.quality);
  const paused = useJourneyStore((s) => s.paused);

  return (
    <Canvas
      shadows={{ type: PCFSoftShadowMap, enabled: quality !== "baja" }}
      dpr={[1, 2]}
      frameloop={paused ? "demand" : "always"}
      camera={{ position: [-26, 6, 32], fov: 45 }}
      className="!absolute inset-0"
      onCreated={({ gl, scene }) => {
        gl.toneMapping = ACESFilmicToneMapping;
        gl.toneMappingExposure = 1.0;
        // Hook de depuración/telemetría para mediciones E2E (sin datos sensibles).
        (window as unknown as Record<string, unknown>).__cale3d = { gl, scene };
      }}
    >
      <QualityManager quality={quality} />
      <Suspense fallback={null}>{children}</Suspense>
    </Canvas>
  );
}

export { CanvasFallback };
